import {CONSTANTS} from "../constants/constants";

const {
  PROFILE,
  AUTH,
  HOME,
  PROPERTY,
  CAR,
  TOUR,
  PROPERTY_SEARCH,
  CAR_SEARCH,
  TOUR_SEARCH,
} = CONSTANTS.ROUTES;

export const MOBILE_NAV_VISIBLE_ROUTES = [
  HOME.path,
  PROPERTY.path,
  CAR.path,
  TOUR.path,
  PROFILE.path,
  AUTH.path,
  PROPERTY_SEARCH.path,
  CAR_SEARCH.path,
  TOUR_SEARCH.path,
];

export const HEADER_HIDDEN_ROUTES = [
  HOME.path,
  PROPERTY.path,
  CAR.path,
  TOUR.path,
];